import { UUID as PBUUID } from "gen/proto/uuid/models_pb"
import { UUID } from "shared-ts/classes/uuid"
import { WebUrl } from "shared-web/lib/webUrl"

const BASE_DELIVERIES_PATH = "/pos/deliveries"

export function deliveriesCalendar(): WebUrl {
  return {
    pathname: `${BASE_DELIVERIES_PATH}/calendar`,
  }
}

export function deliveriesList(): WebUrl {
  return {
    pathname: `${BASE_DELIVERIES_PATH}/list`,
  }
}

export function delivery(id?: PBUUID): WebUrl {
  return {
    pathname: `${BASE_DELIVERIES_PATH}/${UUID.idString(id)}`,
  }
}
